<div
  class="form-input-checkbox"
  [ngClass]="[config.name + '-container', withPadding ? 'dynamic-field' : '']"
  [formGroup]="group"
  [attr.data-test]="config.name"
>
  <label>{{ config.label | translate }}</label>
  <cwc-checkbox [formControlName]="config.name" designVersion="v2">{{ config.placeholder | translate }}</cwc-checkbox>
</div>